import { gql } from "@apollo/client";

export const TRAILHEAD_RANKS_QUERY = gql`
  fragment TrailheadRank on TrailheadRank {
    __typename
    title
    requiredPointsSum
    requiredBadgesCount
    imageUrl
  }

  fragment PublicProfile on PublicProfile {
    __typename
    trailheadStats {
      __typename
      earnedPointsSum
      earnedBadgesCount
      completedTrailCount
      rank {
        ...TrailheadRank
      }
      nextRank {
        ...TrailheadRank
      }
    }
  }

  query GetTrailheadRank(
    $trailblazerId: String
    $queryProfileById: Boolean!
    $slug: String
    $queryProfileBySlug: Boolean!
  ) {
    siteInfo @client {
      urls {
        trailhead
        trailheadRanks
      }
    }

    # Local State query for TBID
    profileUser @client {
      isSelf @client
      id @client @export(as: "trailblazerId")
    }

    # Local State query for slug
    chassis @client {
      profile {
        username @export(as: "slug")
      }
      isSelf
    }

    # NOTE: it seems that when 'aliases' are used and resolved, the client side queries above are not executed anymore.

    profileById: profile(trailblazerId: $trailblazerId)
      @include(if: $queryProfileById) {
      ... on PublicProfile {
        ...PublicProfile
      }
      ... on PrivateProfile {
        __typename
      }
    }

    profileBySlug: profile(slug: $slug) @include(if: $queryProfileBySlug) {
      ... on PublicProfile {
        ...PublicProfile
      }
      ... on PrivateProfile {
        __typename
      }
    }
  }
`;
